import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserStoreService } from '../services/user-store.service';

export const superAdminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userStore = inject(UserStoreService);

  return userStore.isSuperAdmin() ? true : router.parseUrl('/');
};
